import { EnrolState } from 'enum/enrol-state.enum'
import api from '../..'

export type CreateApplicationAttributes = {
  state?: EnrolState
  stateAdmin?: EnrolState
  note?: string
  courseId?: number
  answer?: string
  answerAdmin?: string
  manuallyAssigned?: boolean
  mandatory?: boolean
}

const createManualAssignation = (
  enrol: CreateApplicationAttributes,
  userIds
) => {
  return api.post(`administration/monitoring/manual_enrols`, {
    enrol: { ...enrol, userIds },
  })
}

export default createManualAssignation
